import { a as ethereumNetworkInfo } from './ethereum-81afa4d8.js';

const explorerLink = (payload) => {
  const networkURL = ethereumNetworkInfo.get(payload.network).scanner;
  switch (payload.type) {
    case 'wallet':
      if (['matic', 'mumbai'].includes(payload.network.toLowerCase())) {
        return `${networkURL}/address/${payload.address}/token-transfers`;
      }
      else if (['fuji', 'avalanche'].includes(payload.network.toLowerCase())) {
        return `${networkURL}/address/${payload.address}${payload.isTokenTransfer ? '#transactions' : ''}`;
      }
      else if (['klaytn', 'baobab'].includes(payload.network.toLowerCase())) {
        return `${networkURL}/account/${payload.address}${payload.isTokenTransfer ? '?tabId=txList' : ''}`;
      }
      {
        return `${networkURL}/address/${payload.address}${payload.isTokenTransfer ? '#tokentxns' : ''}`;
      }
    case 'onchainid':
      if (['klaytn', 'baobab'].includes(payload.network.toLowerCase())) {
        return `${networkURL}/account/${payload.address}`;
      }
      else {
        return `${networkURL}/address/${payload.address}`;
      }
    case 'token':
      if (['klaytn', 'baobab'].includes(payload.network.toLowerCase())) {
        return `${networkURL}/account/${payload.address}`;
      }
      else {
        return `${networkURL}/token/${payload.address}`;
      }
    case 'transaction':
      return `${networkURL}/tx/${payload.address}`;
  }
};

export { explorerLink as e };
